import {
    forwardRef,
    useImperativeHandle,
    useRef,
    useState,
    useEffect,
} from 'react'

import DataList from '../../../../../../Components/DataList'
import StatusIcon from '../../../../../../Components/Common/StatusIcon'

const EducationInput = forwardRef(({ title, arrayOf, data, isSelected, handleFieldSelection }, ref) => {

    const dataListRef = useRef()
    const [isOpen, setIsOpen] = useState(isSelected)
    const [completed, setCompleted] = useState(false)

    useEffect(() => {
        setIsOpen(isSelected)
    }, [isSelected])

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            const educationResults = dataListRef.current.validateAndGetData()
            const isValid = educationResults.isValid;
            setCompleted(isValid)

            return educationResults
        },
    }))

    const handleOpen = () => {
        if (isOpen) {
            setCompleted(dataListRef.current.validateAndGetData().isValid)
        }
        if (isSelected) {
            setIsOpen(!isOpen)
            return
        }
        handleFieldSelection()
    }

    return (
        <div className="mb-4">

            <button
                onClick={handleOpen}
                className="w-full flex justify-between items-center py-2 px-0"
            >
                <span className="text-lg font-semibold">{title}</span>
                <span className="pr-4 flex items-center gap-1">
                    {<StatusIcon isOpen={isOpen} completed={completed} />}
                    {isOpen ? '▲' : '▼'}
                </span>
            </button>
            <div className={`${!isOpen ? 'hidden' : ''} pt-2`}>
                <DataList
                    ref={dataListRef}
                    attributes={arrayOf.attributes}
                    data={data || [{}]}
                    title={"Education"}
                />
            </div>
        </div>
    )

})
export default EducationInput
